// extracted by mini-css-extract-plugin
export default {"container":"container_LHVL3","item":"item_ANN8i"};